export default __webpack_public_path__ + "static/media/redirectBlue.aabc4184.svg";